import * as routes from "../../constants/routes";
import BoxLink from "../BoxLink";
import Column from "../grid/Column";
import Container from "../grid/Container";
import React from "react";
import Row from "../grid/Row";
import styles from "./LegalInfo.module.css";
import TextLink from "../TextLink";

const strings = {
    seeRates: "See Rates and Other Info",
    disclosure1: "California residents: please click ",
    disclosure2: " to access and review the Bank’s California notice at collection.",
    here: "here",
    patriotAct:
        "Patriot Act Notice: Federal Law requires all financial institutions to obtain, verify and record information that identifies each person who opens an account, including your name, address, date of birth, social security number and other information that will allow us to verify your identity.",
};

const privacyLinkTo = "https://www.1fbusa.com/ca-privacy#section2Header";

type Props = {
    renderInterestRates: boolean;
    showOnlyPatriotAct?: boolean;
};

export default function LegalInfo(props: Props) {
    function renderPatriotAct() {
        return (
            <>
                <Row>
                    <Column>
                        <div className={styles.patriotAct}>{strings.patriotAct}</div>
                    </Column>
                </Row>
            </>
        );
    }
    return (
        <Container className={styles.bottomContainer}>
            {props.showOnlyPatriotAct ? (
                renderPatriotAct()
            ) : (
                <>
                    <Row>
                        {props.renderInterestRates ? (
                            <>
                                <Column large={6}>
                                    <BoxLink
                                        className={styles.seeRates}
                                        to={routes.INTEREST_DISCLOSURE}
                                        label={strings.seeRates}
                                    />
                                </Column>
                                <Column large={6}>
                                    <div className={styles.privacyText}>
                                        {strings.disclosure1}
                                        <TextLink
                                            className={styles.privacyLink}
                                            href={privacyLinkTo}
                                            text={strings.here}
                                        />
                                        {strings.disclosure2}
                                    </div>
                                </Column>
                            </>
                        ) : (
                            <Column large={12}>
                                <div className={styles.soloText}>
                                    {strings.disclosure1}
                                    <TextLink
                                        className={styles.privacyLink}
                                        href={privacyLinkTo}
                                        text={strings.here}
                                    />
                                    {strings.disclosure2}
                                </div>
                            </Column>
                        )}
                    </Row>
                    {renderPatriotAct()}
                </>
            )}
        </Container>
    );
}

LegalInfo.defaultProps = {
    renderInterestRates: true,
};
